export default "__VITE_ASSET__BsXSHbGg__"